import HeartIcon from '../assets/images/icons/icon-heart.png';
import { PartnerWithCategory } from '../types/types.ts';
import { useFetchPartnersByCategory } from '../hooks/useFetchPartnersByCategory.ts';
import { useFetchCategories } from '../hooks/useFetchCategories.ts';
import SmileIcon from '../assets/images/icons/icon-smile.png';
import { IMAGE_BASE_URL } from '../constants/config.ts';

interface QuestionnairePartnersContentProps {
  categoryId: string;
  setPartner: (partner: PartnerWithCategory) => void;
  userSelectedPartners: PartnerWithCategory[];
}

const QuestionnairePartnersByCategory: React.FC<QuestionnairePartnersContentProps> = ({
  categoryId,
  setPartner,
  userSelectedPartners
}) => {
  const { data: categories } = useFetchCategories();
  const { data: partners } = useFetchPartnersByCategory({ categoryId });
  const category = categories?.find(category => category.id === categoryId);

  const handlePartnerClick = (partner: PartnerWithCategory) => {
    setPartner(partner);
  };

  return (
    <>
      <div>
        <h2 className="fz-18 font-yettel-bold text-center mb-2">{category?.name}</h2>
      </div>
      <div className="content">
        {partners?.map(partner => {
          return (
            <div
              key={partner.id}
              className={`${userSelectedPartners.find(p => p.id === partner.id) ? 'partner-item partner-item--active' : 'partner-item'}`}
              onClick={() => handlePartnerClick(partner)}
            >
              <div className="partner-user-selected__image d-flex align-items-center">
                <img
                  className="partner-icon"
                  src={
                    userSelectedPartners.find(p => p.id === partner.id)
                      ? HeartIcon
                      : partner.image !== null && partner.image !== 'unknown'
                        ? `${IMAGE_BASE_URL}/${partner.image}`
                        : SmileIcon
                  }
                  alt={partner.name}
                />
              </div>
              <p className="font-yettel-light text-center fz-14 pt-1 mb-2">{partner.name}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default QuestionnairePartnersByCategory;
